import React from 'react'

export type PropsIconDownload = {
    onClick: () => void
    nameToolTip?:string
}

const IconDownload = (props:PropsIconDownload) => {
    return (
        <i
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title= {props.nameToolTip?props.nameToolTip:"Descargar Archivo"}
            onClick={() => props.onClick()}
            className="fas fa-download download buttonDownload"
            aria-hidden="true">
        </i>
    )
}
export default IconDownload;
